/**
 * Block script.
 *
 * @package
 * @since 2.0.0
 */

// add JS here.
import Swiper from 'swiper';
import { Navigation, Pagination } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
if (
	( 'complete' === document.readyState ||
		'loading' !== document.readyState ) &&
	! document.documentElement.doScroll
) {
	testimonialsSlider();
} else {
	document.addEventListener( 'DOMContentLoaded', testimonialsSlider );
}

function testimonialsSlider() {
	new Swiper( '.testimonials-swiper', {
		loop: true,
		modules: [ Navigation, Pagination ],
		slidesPerView: 1,
		spaceBetween: 24,
		breakpoints: {
			600: {
				centeredSlides: true,
				slidesPerView: 1.5,
				initialSlide: 1,
			},
			900: {
				centeredSlides: true,
				slidesPerView: 3,
				initialSlide: 1,
			},
		},
		pagination: {
			el: '.swiper-pagination',
		},
		navigation: {
			nextEl: '.testimonials-swiper-next',
			prevEl: '.testimonials-swiper-prev',
		},
	} );
}
